import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/CustomAuthContext';
import './Header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleLogin = () => {
    navigate('/login');
    setIsMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-container">
        {/* Mobile menu button */}
        <button
          className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Desktop navigation */}
        <nav className={`header-nav ${isMenuOpen ? 'nav-open' : ''}`}>
          {user ? (
            <>
              <button
                onClick={() => handleNavigation('/price-history')}
                className="nav-link"
              >
                Browse Data
              </button>
              <button
                onClick={() => handleNavigation('/damage-calculator')}
                className="nav-link calc-link"
              >
                🧮 Calculator
              </button>
              <button
                onClick={() => handleNavigation('/map')}
                className="nav-link map-link"
              >
                🗺️ Map
              </button>
              <button
                onClick={() => handleNavigation('/submit-data')}
                className="nav-link"
              >
                Submit Data
              </button>
              {(user.role === 'checker' || user.role === 'admin') && (
                <button
                  onClick={() => handleNavigation('/review-submissions')}
                  className="nav-link admin"
                >
                  Review
                </button>
              )}
              {user.role === 'admin' && (
                <button
                  onClick={() => handleNavigation('/admin-panel')}
                  className="nav-link admin"
                >
                  Admin
                </button>
              )}
              <div className="user-menu">
                <span className="user-info">
                  {(user as any).displayName || user.username} ({user.role})
                </span>
                <button
                  onClick={() => handleNavigation('/profile')}
                  className="profile-btn"
                >
                  Profile
                </button>
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </div>
            </>
          ) : (
            <div className="nav-actions">
              <button
                onClick={() => handleNavigation('/price-history')}
                className="nav-link browse-link"
              >
                Browse Data
              </button>
              <button
                onClick={() => handleNavigation('/damage-calculator')}
                className="nav-link calc-link"
              >
                🧮 Calculator
              </button>
              <button
                onClick={() => handleNavigation('/map')}
                className="nav-link map-link"
              >
                🗺️ Map
              </button>
              <button
                onClick={handleLogin}
                className="nav-link"
              >
                Login
              </button>
            </div>
          )}
        </nav>

        {/* Brand — pinned to the right */}
        <div className="header-right">
          <button
            onClick={() => handleNavigation('/')}
            className="logo-button"
          >
            <h1>PRO Market History</h1>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
